import React, { FC, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { FormControlLabel, Grid } from '@mui/material'
import { SelectionPaneContext } from '../../../components/selectionPane/components/SelectionPaneContext'
import { CalendrierContext } from '../context/CalendrierContext'
import { lotTypesEnum } from '../../../enums/lot/lotTypesEnum'
import IOSSwitch from '../../../components/switch/IOSSwitch'
import styles from '../../../styles'
import { makeStyles } from 'tss-react/mui'

const SwitchVisiteParking: FC = () => {
	const intl = useIntl()
	const { classes } = useStyles()

	const { currentOffer } = useContext(SelectionPaneContext)
	const { visiteParking, setVisiteParking } = useContext(CalendrierContext)

	return (
		<Grid container item xs={12} paddingLeft="16px">
			{currentOffer?.type === lotTypesEnum.apartment ? (
				<FormControlLabel
					control={<IOSSwitch checked={visiteParking} onChange={(event: React.ChangeEvent<HTMLInputElement>) => setVisiteParking(event.target.checked)} name="checkedB" />}
					label={intl.formatMessage({ id: 'visites.popin.priseRDV.recapitulatif.switch' })}
					className={classes.controlLabelStyle}
				/>
			) : (
				<FormattedMessage
					id="visites.popin.priseRDV.recapitulatif.parking"
					defaultMessage="Pensez à amener votre voiture pour essayer la place de parking"
					description="Texte pour une offre de type Parking"
				/>
			)}
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	controlLabelStyle: {
		margin: 0,
		'& > span:last-child': {
			marginLeft: 17,
			...styles(theme).text0,
			fontSize: 13,
			lineHeight: '17px'
		}
	}
}))

export default SwitchVisiteParking